import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, HostListener, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[primary-button], button[secondary-button]',
  standalone: true,
  template: `
    <ng-content label />
    <ng-content select="[icon]" />
  `,
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @HostBinding('class.disabled')
  @Input({ transform: booleanAttribute })
  disabled: boolean = false;

  /** HOST ATTRIBUTES */
  @HostBinding('attr.role')
  role: string = 'button';

  @HostBinding('attr.tabindex')
  tabIndex: number = 0;

  // Optional attributes
  // (negative attribute only works with secondary buttons)
  @Input({ transform: booleanAttribute }) small?: boolean | string;
  @Input({ transform: booleanAttribute }) negative?: boolean | string;

  /**
   * stopPropagationIfDisabled
   * prevent and stop event propagation
   * if button is disabled.
   *
   * @param event Event
   * @returns boolean
   */
  @HostListener('click', ['$event'])
  @HostListener('Keydown.space', ['$event'])
  @HostListener('Keydown.enter', ['$event'])
  stopPropagationIfDisabled(event: Event): boolean {
    if (this.disabled) {
      event.stopImmediatePropagation();
      return false;
    }
    return true;
  }
}
